import { render, staticRenderFns } from "./categorySettingEdit.vue?vue&type=template&id=b1d6b8f4"
import script from "./categorySettingEdit.vue?vue&type=script&lang=js"
export * from "./categorySettingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports